/*eslint @typescript-eslint/no-explicit-any:0 */
// declare let bodymovin: any;
import * as bodymovin from '../vendor/lottie.min.js';
jQuery(function () {
    $(document).ready(function () {
        var lottieVideo = document.getElementById('lottie-video');
        var animation = '/animations/Master_minVilla_gif.json';
        if (!lottieVideo) {
            return;
        }
        bodymovin.loadAnimation({
            wrapper: lottieVideo,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: animation
        });
    });
});
